// Clean product types for use in components
// CTA types and helpers
export * from './catalogMode';
export * from './cta';
// Marketing status (badges) types and helpers
export * from './marketing-status';
// Static data for Storybook and development
export * from './static-data';
export * from './types';
// Product URL builders
export * from './urls';
export * from './strapKeyFeatures';
export * from './sizingTool';
export * from './resolveStrapTitle';
export { resolveModelStoryViewModel, resolveStoryImage } from './resolveModelStory';
export {
  generatePDPBreadcrumbs,
  generateStrapBreadcrumbs,
  type PDPBreadcrumbItem,
  type PDPBreadcrumbTranslations,
  type StrapBreadcrumbTranslations,
} from './generatePDPBreadcrumbs';

/**
 * Convert SKUs to slugs for Saleor queries
 * In this codebase, SKUs and slugs are the same
 */
export function skusToSlugs(skus: string[]): string[] {
  return skus;
}
